// extracted by mini-css-extract-plugin
export default {"machineCreateButton":"machines_machineCreateButton__cwm60","machineEditButton":"machines_machineEditButton__fDgmy","editUpdateStatusButton":"machines_editUpdateStatusButton__AzpBk"};